<template>
  <li class="lang">
    <a @click.prevent="setLocale('en')" v-if="$i18n.locale === 'mn'">
      <img src="@/assets/img/eng.png"
    /></a>
    <a @click.prevent="setLocale('mn')" v-if="$i18n.locale === 'en'">
      <img src="@/assets/img/mgl.png" />
    </a>
  </li>
</template>

<script>
export default {
  methods: {
    setLocale(locale) {
      this.$i18n.locale = locale;
      this.$router.push({
        params: { lang: locale }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.lang {
  img {
    height: 20px;
    width: 20px;
    margin-top: 4px;
  }
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
